import type { DtoCustomerContact } from '@repo/api-types/order-retrieval';
import { isObject } from '@repo/utils/type.utils';

import type { Customer2, CustomerInformation as DraftCustomerInformation } from './draft.types';

export function isDtoCustomerContact(value: unknown): value is DtoCustomerContact {
    return isObject(value) && 'customerContactDetails' in value;
}

export interface CustomerData extends Partial<Customer2> {
    businessName?: string;
    landlinePhone?: string;
}

export interface CustomerInformation extends DraftCustomerInformation {}
